import type {
    ArtboardGuideDrawableObjectType,
    DrawableCircle,
    DrawableImage,
    DrawableLine,
    DrawablePolygon,
    DrawableRect,
    DrawableText,
} from '#shared/types/design-lab/ArtboardGuideDrawableObjectType';

export const INVALID_FINISHED_ARTWORK_DIMENSIONS_MESSAGE =
    'This file’s dimensions don’t match the required print size for this product. Verify that you’re using the correct template and refer to the Setup Guide for instructions on setting up and saving your artwork correctly. Then, try uploading your file again.';

export const FINISHED_ARTWORK_CTA_DESCRIPTION =
    "Upload your completed artwork formatted to Roastar's template specifications.";

export function isRectElement(
    element: ArtboardGuideDrawableObjectType,
): element is { rect: DrawableRect } {
    return 'rect' in element;
}

export function isPolygonElement(
    element: ArtboardGuideDrawableObjectType,
): element is { polygon: DrawablePolygon } {
    return 'polygon' in element;
}

export function isLineElement(
    element: ArtboardGuideDrawableObjectType,
): element is { line: DrawableLine } {
    return 'line' in element;
}

export function isCircleElement(
    element: ArtboardGuideDrawableObjectType,
): element is { circle: DrawableCircle } {
    return 'circle' in element;
}

export function isTextElement(
    element: ArtboardGuideDrawableObjectType,
): element is { text: DrawableText } {
    return 'text' in element;
}

export function isImageElement(
    element: ArtboardGuideDrawableObjectType,
): element is { image: DrawableImage } {
    return 'image' in element;
}
